import React, { useState } from 'react'
import { Col, Container, Row, Tab } from 'react-bootstrap'
import { Tabs } from '../../components/Tabs/Tabs'
import { PresetTab } from './AIFeaturePresets/PresetTab'
import { useNavigate, useParams } from 'react-router-dom'
import { DataRetentionPolicies } from './DataRetentionPolicies/DataRetentionPolicies'
import { useZocksQuota } from '../../components/ScopedBlock/hooks'
import PrizeBadge from '../../components/ScopedBlock/PrizeBadge.svg?url'
import { MeetingTemplateTab } from './MeetingTemplates/MeetingTemplateTab'
import { Settings } from './Settings/Settings'
import { AIFormTab } from './AIForms/AIFormTab'
import { EmailTypesTab } from './EmailTypes/EmailTypesTab'
import { DocumentTypesTab } from './DocumentTypes/DocumentTypesTab'

export const Setup: React.FC = () => {
  const { activeTab = 'meeting-types' } = useParams()
  const [selectedTab, setSelectedTab] = useState(activeTab)
  const { hasQuota } = useZocksQuota()

  const navigate = useNavigate()

  const changeTab = (key: string | null) => {
    if (key) {
      setSelectedTab(key)
      navigate(`/workspace/setup/${key}`, { replace: true })
    }
  }

  const retentionEnabled = hasQuota('retention.enabled.value')
  const formEnabled = hasQuota('ai.formFill.value')
  const emailEnabled = hasQuota('integration.emailEnabled.value')
  const documentProcessingEnabled = hasQuota('ai.documentSummaryAgent.value')

  const presetsTitle = <div className='d-flex align-items-center'>Meeting Presets</div>

  const formTitle = (
    <div className='d-flex align-items-center zocks-gap-0.25'>
      {!formEnabled ? <img alt='Upgrade' src={PrizeBadge} /> : ''}
      Forms
    </div>
  )

  const retentionTitle = (
    <div className='d-flex align-items-center zocks-gap-0.25'>
      {!retentionEnabled ? <img alt='Upgrade' src={PrizeBadge} /> : ''}
      Data Retention Policies
    </div>
  )

  const settingsTitle = <div className='d-flex align-items-center'>Settings</div>

  const meetingTemplateTitle = <div className='d-flex align-items-center'>Meeting Types</div>

  const emailTypesTitle = (
    <div className='d-flex align-items-center zocks-gap-0.25'>
      {!emailEnabled ? <img alt='Upgrade' src={PrizeBadge} /> : ''}
      Email Types
    </div>
  )

  const documentTypesTitle = (
    <div className='d-flex align-items-center zocks-gap-0.25'>
      {!documentProcessingEnabled ? <img alt='Upgrade' src={PrizeBadge} /> : ''}
      Document Types
    </div>
  )

  return (
    <Container>
      <Row className='mb-9'>
        <Col>
          <h3>Setup</h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <Tabs onSelect={changeTab} defaultActiveKey={selectedTab} id='setup-tabs' className='d-flex gap-2r mb-3'>
            <Tab className='mt-5' eventKey='meeting-types' title={meetingTemplateTitle}>
              <MeetingTemplateTab />
            </Tab>
            <Tab className='mt-5' eventKey='email-types' title={emailTypesTitle}>
              <EmailTypesTab />
            </Tab>
            <Tab className='mt-5' eventKey='document-types' title={documentTypesTitle}>
              <DocumentTypesTab />
            </Tab>
            <Tab className='mt-5' eventKey='preset' title={presetsTitle}>
              <PresetTab />
            </Tab>
            <Tab className='mt-5' eventKey='forms' title={formTitle}>
              <AIFormTab />
            </Tab>
            {/*<Tab className='mt-5' eventKey='custom-dictionary' title='Custom dictionary'>*/}
            {/*  <CustomDictionary />*/}
            {/*</Tab>*/}
            <Tab className='mt-5' eventKey='data-retention' title={retentionTitle}>
              <DataRetentionPolicies />
            </Tab>
            <Tab className='mt-5' eventKey='settings' title={settingsTitle}>
              <Settings />
            </Tab>
          </Tabs>
        </Col>
      </Row>
    </Container>
  )
}
